'use client';

import type {Locale} from '../../i18n.config';
import type {BlurDataURLs, GuideFM, Content} from '../library/types';
import {useSearchParams} from 'next/navigation';
import GuidesFallback from './GuidesFallback';

type Props = {
  locale: Locale;
  guides: Content<GuideFM>[];
  blurDataURLs: BlurDataURLs;
};

export default function Guides({locale, guides, blurDataURLs}: Props) {
  const searchParams = useSearchParams();
  const game = searchParams?.get('game');

  const filteredGuides = guides.filter((guide) => {
    return !game || guide.frontmatter.gameSlug === game;
  });

  return (
    <GuidesFallback
      locale={locale}
      blurDataURLs={blurDataURLs}
      guides={filteredGuides}
    />
  );
}
